






































































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import TableWidthMixin from '@/common/mixins/table-width';
import Utils from '@/utils/common';
import moment from 'moment';
import PlateInput from '../../../components/plate-input/index.vue';
import { queryMonthCardApplyList, cancelOrder } from '@/api/fixed-car-management';
import * as routerNames from '../router-names';
import { isShiDaill } from '@/utils/env';
@Component({
  name: 'LongRentalCarSign',
  components: {
    ParkingLotSearch,
    PlateInput
  }
})
// @Component
export default class LongRentalCarSign extends Mixins(TableMixin, TableWidthMixin) {
  filterParam: any = {
    parkId: [],
    spaceCode: '',
    applyStatus: '',
    applyTimeStart: '',
    applyTimeEnd: '',
    payStatus: '',
    userType: '01',
    userValue: '',
    cardType: [],
    applyType: [],
    plateHead: '',
    plateTail: ''
  };

  clearPlate = false;
  clear({ defaultParkIdList }) {
    this.clearPlate = true;
    this.filterParam = {
      parkId: defaultParkIdList,
      spaceCode: '',
      applyStatus: '',
      applyTimeStart: '',
      applyTimeEnd: '',
      payStatus: '',
      userType: '01',
      userValue: '',
      cardType: [],
      applyType: [],
      plateHead: '',
      plateTail: ''
    };
    this.fetchTableData();
  }
  private tableLoading: boolean = false;
  private pkApplyId = '';
  private cardId = '';
  isshidaill: boolean = isShiDaill;
  async created() {
    this.fetchTableData();
  }

  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }
  get defaultTime() {
    if (this.filterParam.applyTimeStart && this.filterParam.applyTimeEnd) {
      return [
        this.moment(this.filterParam.applyTimeStart, 'YYYY-MM-DD'),
        this.moment(this.filterParam.applyTimeEnd, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.applyTimeStart) {
      return [this.moment(this.filterParam.applyTimeStart, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  /**
   * 获取列表数据
   */
  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const {
        parkId,
        applyStatus,
        applyTimeStart,
        applyTimeEnd,
        payStatus,
        plateHead,
        plateTail,
        applyType,
        cardType,
        userType,
        userValue
      } = this.filterParam;
      const { data } = await queryMonthCardApplyList({
        parkId: '' + parkId,
        applyStatus: applyStatus,
        applyTimeStart,
        applyTimeEnd,
        payStatus: payStatus,
        plateHead,
        plateTail,
        userType,
        userValue,
        applyType: '' + applyType,
        cardType: '' + cardType,
        currPage: this.current,
        pageSize: this.pageSize
      });
      if (data) {
        const { totalNum = 0, datas = [] } = data;
        this.total = Number(totalNum);
        if (datas.length > 0) {
          this.tableData = datas;
        } else {
          this.tableData = [];
        }
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryMonthCardApplyList  接口调用错误', error);
    } finally {
      this.tableLoading = false;
    }
  }

  private moment = moment;

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  /**
   *  时间
   */

  private onTimeChange(date: any, dateString: any) {
    const [applyTimeStart, applyTimeEnd] = dateString;
    this.filterParam.applyTimeStart = applyTimeStart;
    this.filterParam.applyTimeEnd = applyTimeEnd;
  }

  //订单状态 审核状态
  applyStatusList = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.apply_status);
  //支付状态
  payTypeList = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.pay_status);
  //业务类型
  businessTypeList = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.apply_type);
  //车位用途
  cardTypeList: any = [{ value: '01', label: '产权' }, { value: '02', label: '长租' }];
  //订单来源
  orderSourceList = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_month_card_apply_order_source);
  tableData: any[] = [];
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '订单号',
        dataIndex: 'pkApplyId',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '客户名称',
        dataIndex: 'userName',
        width: 120
      },
      {
        title: '手机号',
        dataIndex: 'phoneNum',
        width: 140
      },
      {
        title: '业务类型',
        dataIndex: 'applyType',
        width: 120,
        scopedSlots: { customRender: 'applyType' }
      },
      {
        title: '车位用途',
        dataIndex: 'cardType',
        width: 120
      },
      {
        title: '车位编号',
        dataIndex: 'spaceCode',
        width: 140
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 240,
        scopedSlots: { customRender: 'plate' }
      },
      {
        title: '申请时间',
        dataIndex: 'applyTime',
        width: 240
      },
      {
        title: '授权期起',
        dataIndex: 'startDate',
        width: 240
      },
      {
        title: '授权期止',
        dataIndex: 'endDate',
        width: 240
      },
      {
        title: '收费套餐',
        dataIndex: 'packageName',
        width: 140,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '总金额',
        dataIndex: 'price',
        width: 120
      },
      {
        title: '订单来源',
        dataIndex: 'orderSource',
        width: 140,
        scopedSlots: { customRender: 'orderSource' }
      },
      {
        title: '订单状态',
        dataIndex: 'applyStatus',
        width: 140,
        scopedSlots: { customRender: 'applyStatus' }
      },
      {
        title: '支付状态',
        dataIndex: 'payStatus',
        width: 140,
        scopedSlots: { customRender: 'payStatus' }
      },
      {
        title: '订单说明',
        dataIndex: 'orderInfo',
        width: 140
      },
      {
        title: '审核人',
        dataIndex: 'reviewer',
        width: 140
      },
      {
        title: '审核时间',
        dataIndex: 'reviewTime',
        width: 240
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 200,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  mounted() {}
  //获取订单来源
  getsourceName(value) {
    let a = [];
    if (value) {
      a = _.filter(this.orderSourceList, function(o) {
        return o.value == value;
      });
      return a.length > 0 ? a[0].label : '--' || '--';
    }
    return '--';
  }
  //获取审核状态
  getReviewName(value) {
    let a = [];
    if (value) {
      a = _.filter(this.applyStatusList, function(o) {
        return o.value == value;
      });
      return a.length > 0 ? a[0].label : '--' || '--';
    }
    return '--';
  }
  //获取支付状态
  getPayName(value) {
    let a = [];
    if (value) {
      a = _.filter(this.payTypeList, function(o) {
        return o.value == value;
      });
      return a.length > 0 ? a[0].label : '--' || '--';
    }
    return '--';
  }
  //去详情页面
  toDetail(record: any, flag: boolean) {
    if (flag) {
      this.$router.push({
        name: routerNames.FIXED_CAR_SIGN_DETAIL,
        query: {
          pkApplyId: record.pkApplyId
        }
      });
    } else {
      this.$router.push({
        name: routerNames.FIXED_CAR_SIGN_REVIEW,
        query: {
          pkApplyId: record.pkApplyId,
          cardId: record.cardId
        }
      });
    }
  }
  cancelFlag: boolean = false;
  // 车牌改变
  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }
  //取消订单
  cancelPay(record: any) {
    const self = this;
    const { pkApplyId, cardId, applyType } = record;
    this.$confirm({
      title: '提示',
      content: `确认取消该订单`,
      async onOk() {
        if (self.cancelFlag) return;
        self.cancelFlag = true;
        try {
          await cancelOrder({ pkApplyId, cardId, applyType });
          self.$message.success('取消订单成功');
          self.fetchTableData();
        } catch (e) {
          console.log('报错==>', e);
          self.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
        } finally {
          self.cancelFlag = false;
        }
      },
      onCancel() {}
    });
  }
}
